var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSedanDriving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 56,
    viewBox: "0 0 139 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.007,
    cy: 45.963,
    rx: 64.947,
    ry: 1.456,
    fill: "#4D6071"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 21.077h2.059c.144 0 .271.093.314.23a18.447 18.447 0 0 0 2.111 4.482l.282.435c-1.391.28-.264.673-2.121 0-1.451-.526-2.682-2.498-3.396-4.019-.254-.539.156-1.128.751-1.128zM20.317 21.998H18.94l-.101-2.86a3.68 3.68 0 0 0-1.637-2.932c3.038.186 3.466 3.455 3.498 4.607.026.922-.245 1.174-.383 1.185z",
    fill: "#8699AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.303 21.077h-6.92c-.595 0-1.005.59-.751 1.128.714 1.522 1.946 3.494 3.398 4.02 1.857.673 5.103.28 6.494 0M69.666 15.315c.324 3.145 1.019 10.315 1.572 16.075M16.652 16.027c.633-.053 2.126.065 3.03.97.75.75.96 2.898.98 4.387a.809.809 0 0 1-.836.816c-1.156-.026-2.69-.11-3.174-.313M14.885 23.999c.296.42 1.412 1.262 3.506 1.262H26.2M104.491 34.053H54.635M137.416 34.053h-13.488",
    stroke: "#4D6071",
    strokeWidth: 0.86,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.524 38.23H52.341M31.674 37.438l-12.511-.906c-1.465-.15-4.354-1.995-4.354-6.182v-6.274c0-.244.103-.475.284-.638l1.37-1.232a.86.86 0 0 0 .284-.64v-4.77c0-1.9 1.54-3.44 3.44-3.44h4.057a.86.86 0 0 0 .366-.082L39.58 6.24c2.283-1.228 7.134-2.927 12.683-4.026 5.151-1.02 12.62-.695 17.598-.62 4.287.064 14.138.762 19.256 3.036 4.424 1.967 11.42 5.652 15.587 7.909a9.37 9.37 0 0 0 3.697 1.079c6.054.504 16.036 2.08 22.741 5.472 2.52 1.274 4.47 3.435 5.795 5.93 1.46 2.75 1.347 3.97.772 6.879a26.525 26.525 0 0 1-1.354 4.67 2.612 2.612 0 0 1-2.435 1.662h-9.846",
    stroke: "#4D6071",
    strokeWidth: 1.72,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m31.852 13.673 69.439.244c.088 0 .12-.116.044-.16-5.278-3.071-11.493-6.831-17.626-8.368-7.573-1.898-26.226-2.716-35.105-.053-5.482 1.645-13.322 6.077-16.798 8.18-.074.044-.04.157.046.157z",
    fill: "#8699AA",
    stroke: "#4D6071",
    strokeWidth: 1.29,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m90.82 15.818-1.564-.05a.842.842 0 0 1-.774-.581l-.484-1.49a1.718 1.718 0 0 1-.079-.661l.095-1.254a.86.86 0 0 1 .885-.794l2.303.072a5.031 5.031 0 0 1 3.543 1.622.503.503 0 0 1 .132.351l-.016.79a.505.505 0 0 1-.13.327 5.047 5.047 0 0 1-3.91 1.668z",
    fill: "#4D6071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.205 10.284c.088.454.31 2.325.398 3.167",
    stroke: "#4D6071",
    strokeWidth: 0.86
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95 28.47H5.184M12.338 23.625H.63M12.335 18.936H5.184M68.498 4.274c.292 2.938.698 7.004.924 9.255M46.58 6.254c-.475 2.224-.762 3.908-1.182 6.844M73.448 17.867h3.934M49.343 17.867h3.934",
    stroke: "#4D6071",
    strokeWidth: 0.86,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4D6071"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.206,
    cy: 33.639,
    r: 10.704,
    transform: "rotate(49.313 42.206 33.64)",
    fill: "#8699AA",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.206,
    cy: 33.638,
    r: 8.884,
    transform: "rotate(49.313 42.206 33.638)",
    fill: "#fff",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.204,
    cy: 33.643,
    r: 3.264,
    fill: "#8699AA",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.938 29.332a6.398 6.398 0 1 1-1.962-1.464",
    strokeWidth: 0.86
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4D6071"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.933,
    cy: 33.68,
    r: 10.704,
    transform: "rotate(-103.908 113.933 33.68)",
    fill: "#8699AA",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.934,
    cy: 33.681,
    r: 8.884,
    transform: "rotate(-103.908 113.934 33.68)",
    fill: "#fff",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.935,
    cy: 33.677,
    r: 3.264,
    transform: "rotate(-153.222 113.935 33.677)",
    fill: "#8699AA",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.768 35.398a6.398 6.398 0 1 1 1.093 2.19",
    strokeWidth: 0.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanDriving);
export default __webpack_public_path__ + "static/media/sedan-driving.0b17fc8765a773d852e6fe5427e35cc1.svg";
export { ForwardRef as ReactComponent };